// Shared payment validation: a check payment must have a due date (checkDate)
export const findChecksMissingDate = (payments = []) =>
  payments.filter(p => p.method === 'check' && p.amount && !p.checkDate);

export const validateCheckDates = (payments = []) =>
  findChecksMissingDate(payments).length === 0;

// Payments that have an amount entered but no payment method selected.
// These are silently dropped on save (filters require method && amount),
// which makes a debt look paid in the UI while nothing is actually recorded.
export const findPaymentsMissingMethod = (payments = []) =>
  payments.filter(p => (parseFloat(p.amount) || 0) > 0 && !p.method);
